/** Imports */
import {defineRouting} from 'next-intl/routing';
import {createNavigation} from 'next-intl/navigation';
import {APP_LOCALES, DEFAULT_APP_LOCALE} from '@/i18n/appLocales';


/// Routing configuration
export const routing = defineRouting({

    // A list of all locales that are supported
    locales: APP_LOCALES,

    // Used when no locale matches
    defaultLocale: DEFAULT_APP_LOCALE,
});

/// Exports
export const {Link, redirect, usePathname, useRouter, getPathname} = createNavigation(routing);
